export { default } from "./FormLabel.mjs";
export * from "./FormLabel.mjs";
export { default as formLabelClasses } from "./formLabelClasses.mjs";
export * from "./formLabelClasses.mjs";